import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import gardenWalls from "./images/gardenbeds/bg-gardenbeds.jpg";
import featureA1 from "./images/gardenbeds/feature-a-1.jpg";
import featureA2 from "./images/gardenbeds/feature-a-2.jpg";
import featureA3 from "./images/gardenbeds/feature-a-3.jpg";
import featureB1 from "./images/gardenbeds/feature-b-1.jpg";
import featureB2 from "./images/gardenbeds/feature-b-2.jpg";
import featureB3 from "./images/gardenbeds/feature-b-3.jpg";
import featureC1 from "./images/gardenbeds/Garden-Walls-Angelus-Tango-Block-Project-Tuscan.jpg";
import featureC2 from "./images/gardenbeds/12-Inch-Planter-Wall-Sand-Stone-Mocha.jpg";
import featureC3 from "./images/gardenbeds/Stonewall-Gray-Moss-Charcoal.jpg";

//SEO
import SEO from "../../../SEO/index.js";
import StructuredData from "../../../SEO/structuredData";

const GardenWalls = () => {
  return (
    <>
      <SEO
        title="Garden Retaining Walls Installation in LA | Pacific Pavingstone"
        description="Garden walls are a great way to take back your Southern California outdoor space and/or segment your landscape from your hardscape. Get started today!"
        profileURL={"https://www.pacificpavingstone.com/services/garden-walls"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "Service",
          name: "Garden Retaining Walls Installation",
          image:
            "https://www.pacificpavingstone.com/static/media/bg-gardenbeds.ea611dc9.jpg",
          description:
            "Garden walls are a great way to take back your Southern California outdoor space and/or segment your landscape from your hardscape. Get started today!",
          brand: "Pacific Pavingstone",
          areaServed: "Southern California",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          provider: "Pacific Pavingstone",
          URL: "https://www.pacificpavingstone.com/services/garden-walls",
          potentialAction: "Schedule a Consultation",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "1",
            reviewCount: "1",
          },
          review: {
            "@type": "Review",
            name: "S.L.",
            reviewBody:
              "This company is one of the best and most ethical company I have ever worked with. I have had extensive remodeling at my house. No one I mean no one has ever been more responsible and punctual. They finished my driveway a week ahead of schedule. I'm very impressed. Even after the job was done they contacted me and wanted to make sure we were happy. The crew and supervisorCraig Jorge Onicemo, Hugo and Javier are all fantastic and professional group. Trust me if need any work done these guys are very legit and impressive. You would not regret it. Their work is very clean and design is amazing. Thank you Pacific paving Stone, GREAT JOB",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
              worstRating: "1",
            },
            datePublished: "2021-10-08",
            author: { "@type": "Person", name: "S.L." },
            publisher: { "@type": "Organization", name: "Pacific Pavingstone" },
          },
        }}
      />
      <div className="container-fluid page-featured">
        <Hero title={"Garden Walls"} background={gardenWalls} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-9">
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <p>
                  Slopes and hillsides add to the charm and uniqueness of
                  Southern California real estate. However, if you aren’t
                  careful, a hillside can eat away at the usability of you
                  outdoor space. Like it or not, topographical challenges are
                  something Southern California home owners have to deal with.
                  This challenge often leads to retaining wall, or garden wall,
                  construction. Garden walls are a great way to take back your
                  outdoor space and/or segment your landscape from your
                  hardscape.
                </p>
              </div>
            </div>
            <div className="row justify-content-center mt-5">
              <div className="col-12">
                <h2 className="text-center text-uppercase">
                  Materials for Los Angeles Retaining Walls
                </h2>
                <p>
                  The overwhelming majority of retaining walls installed in
                  Southern California are smaller walls made from manufactured
                  concrete blocks. There are 2 primary applications:
                </p>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Masonry Retaining Walls
                </h2>
                <p>
                  Some projects use concrete blocks much like a mason uses for
                  the foundation of homes. These materials are laid in a similar
                  fashion with rebar supports added for additional supports.
                  These walls then are most often covered with stone veneer to
                  match existing architecture of homes or other elements of the
                  landscape design. This allows for unlimited customizability so
                  the retaining wall can match any design aesthetic.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Interlocking Concrete Block Retaining Walls
                </h2>
                <p>
                  If you have or are planning on installing a paving stone
                  pathway, patio or pool deck, consider adding a retaining wall
                  of the same material to round out your space and keep it
                  cohesive. Paving stone manufacturers offer a variety of wall
                  blocks that match their other projects or can be used on other
                  areas of your property. These types of walls typically are the
                  most cost-effective of retaining wall options you will find
                  and are extremely durable if installed properly.
                  <br />
                  <br />
                  These walls are topped with cap stone that is glued fast for a
                  slight overhang.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12 mt-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureC1}
                        alt="Angelus Tango Block Project In Tuscan"
                      />
                      <div className="text">
                        <p>
                          Angelus Tango Block Project
                          <br />
                          In Tuscan
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureC2}
                        alt="
                          Angelus Planter Wall In Sand-stone Mocha"
                      />
                      <div className="text">
                        <p>
                          Angelus Planter Wall
                          <br />
                          In Sand-stone Mocha
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureC3}
                        alt="
                          Angelus Stonewall II Olympic Series In Gray-Charcoal"
                      />
                      <div className="text">
                        <p>
                          Angelus Stonewall II Olympic Series
                          <br />
                          In Gray-Charcoal
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GardenWalls;
